export enum PERIOD_DAY {
	None = 0,
	Morning = 1,
	Afternoon = 2,
	Night = 4,
}
